/**
 * 提案書サンプルスライド画像
 * Figma Make v3 資料修正版から移植した 10 枚のスライド PNG。
 * ランディングページのカルーセルとサンプルモーダル内のスクロール表示で共用する。
 */
import slide1 from '@/assets/8310eafceb61ce993b8b67171f186896598f53a0.png';
import slide2 from '@/assets/129c1e65929da7d2d72389d3da0dd7144569a4a9.png';
import slide3 from '@/assets/bb3172b9ff7841ab5f5402aa135ac43fdedb5f7c.png';
import slide4 from '@/assets/121cdbaa4e383b9bce823a63b8e82c2ae5a9d666.png';
import slide5 from '@/assets/4e8b46409d4619249e553d0db53cd38f8a5b53f8.png';
import slide6 from '@/assets/970182e985b3852e08aa7d0b9e978126dc0e6320.png';
import slide7 from '@/assets/72ff801ad20014e8e6496d022dafdabf7542b41b.png';
import slide8 from '@/assets/a4511a4e0b949c36690947b133be7f1034ed7f48.png';
import slide9 from '@/assets/a6bf8333f1d735ca165a1ec9931fddc556519547.png';
import slide10 from '@/assets/2466cfc76796a5e55925947a2c30e6eca70cb062.png';

export const proposalSlides = [
  slide1,
  slide2,
  slide3,
  slide4,
  slide5,
  slide6,
  slide7,
  slide8,
  slide9,
  slide10,
] as const;

/**
 * カルーセル用に 2 枚ずつペアに分割したもの。
 * 各カードは上段・下段の 2 スライドをスタックして表示する。
 */
export const proposalSlidePairs: ReadonlyArray<readonly [string, string]> = [
  [slide1, slide2],
  [slide3, slide4],
  [slide5, slide6],
  [slide7, slide8],
  [slide9, slide10],
];
